
export const ActivitySubTypes = {
    outBoundCall: 1,
    inBoundCall: 2
};
